import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { StoreTheme } from "../../lib/types";

export const useThemes = () =>
	useQuery({
		queryKey: ["themes"],
		queryFn: () => api.get<{ items: StoreTheme[] }>("/api/themes"),
		staleTime: 5 * 60 * 1000,
	});
